<template>
  <section>
    <h3 class="step-two__header">Step 2: Validate your data</h3>
    <table v-if="csvHeaders.length <= 3">
      <tr>
        <th v-for="(item, index) in csvHeaders" :key="index" class="step-two__th">{{ item }}</th>
      </tr>
      <tr v-for="(item,index) in csvData" :key="index">
        <td
          v-for="(itm,index) in item"
          :key="index"
          :class="index != 0 ? 'step-two__centeredTd': ''"
        >
          <a :href="itm" v-if="index==0" target="_blank">{{itm}}</a>
          <div v-else>{{itm}}</div>
        </td>
      </tr>
    </table>
    <table v-else>
      <tr>
        <th
          v-for="(item, index) in csvHeaders.slice(0, 3)"
          :key="index"
          class="step-two__th"
        >{{ item }}</th>
      </tr>
      <tr v-for="(item,index) in csvData" :key="index">
        <td
          v-for="(itm,index) in item.slice(0, 3)"
          :key="index"
          :class="index != 0 ? 'step-two__centeredTd': ''"
        >
          <a :href="itm" v-if="index==0" target="_blank">{{itm}}</a>
          <div v-else>{{itm}}</div>
        </td>
      </tr>
    </table>
  </section>
</template>
<script>
  export default {
    name: 'page-three',
    computed:{
      csvHeaders() {
        return this.$store.getters.getCsvHeaders;
      },
      csvData() {
        return this.$store.getters.getCsvData;
      }
    },
  }
</script>
<style lang="scss" scoped>
.step-two {
  &__header {
    margin-top: 0px;
    margin-bottom: 10px;
  }

  &__th {
    text-transform: uppercase;
    text-align: center;
    padding: 0 7px;
  }

  &__centeredTd {
    text-align: center;
  }
}
</style>
